import type { PurchaseItemsReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

export const purchaseItemsKeys = {
  report: (filters: ReportFilters, supplier: string) => ['reports', 'purchase-items', filters, supplier] as const,
};

/** Branch + range + supplier only: search runs client-side over the whole window. */
export function fetchPurchaseItems(
  filters: ReportFilters,
  supplier: string,
  signal?: AbortSignal,
): Promise<PurchaseItemsReport> {
  const qs = queryString({ branchId: filters.branchId, from: filters.from, to: filters.to, supplier });
  return portalApi.get<PurchaseItemsReport>(`/portal/reports/purchase-items${qs}`, { signal });
}
